import { ProtectedRoute } from "@/components/ProtectedRoute";
import { BooksPage } from "@/pages/books/BooksPage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/books/")({
  component: ProtectedBooksPage,
});

function ProtectedBooksPage() {
  return (
    <ProtectedRoute>
      <BooksPage />
    </ProtectedRoute>
  );
}
